var _rect, _rect2, _circle, _path, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOutdatedApp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 120,
  fill: "none",
  viewBox: "0 0 120 120"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 60,
  height: 90,
  x: 30,
  y: 15,
  stroke: "currentColor",
  strokeWidth: 3,
  rx: 8
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 60,
  x: 40,
  y: 25,
  fill: "currentColor",
  opacity: 0.1,
  rx: 4
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 95,
  r: 4,
  fill: "currentColor"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 4,
  d: "M60 45v20"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 75,
  r: 3,
  fill: "currentColor"
})));
export default SvgOutdatedApp;